export default "__VITE_ASSET__BCxGn3Og__"